<aero-form class="resume-contact-dialog-container" submitButtonLabel="{{ 'saveButton' | transloco }}"
  [showCancelButton]="true" (onCancel)="closeContactInfoDialog()" (onSubmit)="handleFormSubmission( $event )">
  <i class="contact-dialog-close fas fa-times" (click)="closeContactInfoDialog()">
  </i>
  <i class="far fa-address-card"></i>
  <h1 transloco="resume.contactInfo.label">Contact Information</h1>
  <p transloco="resume.contactInfo.summary" class="resume-contact-modal-summary">
    Enter your contact information so others can reach you with potential opportunities.
  </p>

  <div class="resume-input-info-container">

    <aero-input type="text" [id]="'bulbResumeFullName'" [required]="true" label="{{ 'fullNameLabel' | transloco }}"
      name="fullName" [(ngModel)]="resumeContactDetail.fullName" [maxlength]="70">
    </aero-input>

    <aero-input type="email" [required]="false" [id]="'bulbResumeEmailAddress'"
      label="{{ 'email.label' | transloco }}" errorMessage="{{ 'resume.modal.emailErrorMessage' | transloco }}"
      name="emailAddress" [(ngModel)]="resumeContactDetail.emailAddress" [email]="true" bulbEmailUnique>
    </aero-input>

    <aero-input [id]="'bulbResumePhoneNumber'" type="text" label="{{ 'phoneNumberLabel' | transloco }}"
      [required]="false" name="phoneNumber" [(ngModel)]="resumeContactDetail.phoneNumber" [maxlength]="20">
    </aero-input>

    <aero-input type="text" [id]="'bulbResumeLocation'"
      label="{{ 'resume.contactInfo.location.label' | transloco }}" [required]="false"
      hintMessage="{{ 'resume.contactInfo.location.hintMessage' | transloco }}" name="location"
      [(ngModel)]="resumeContactDetail.location" [maxlength]="70">
    </aero-input>

  </div>
</aero-form>